import React, { useEffect, useState } from "react";
import WorkflowBubbles from "./WorkflowBubbles";
import api from "../api";

const Orders = ({ currentGardener, isDemoMode }) => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [orderItems, setOrderItems] = useState({});
    const [selectedOrderID, setSelectedOrderID] = useState(null);

    useEffect(() => {
        const fetchOrders = async () => {
            if (!currentGardener?.id) return;

            setLoading(true);
            setError("");

            try {
                const response = await api.get(
                    `/gardenerOrders/gardener/${currentGardener.id}`
                );
                const sortedOrders = [...response.data].sort(
                    (a, b) => b.orderID - a.orderID
                );

                setOrders(sortedOrders);
                setSelectedOrderID(sortedOrders[0]?.orderID || null);

                // fetch items for each order
                const itemsPromises = response.data.map(order =>
                    api.get(`/gardenerOrders/items/${order.orderID}`)
                );

                const itemsResponses = await Promise.all(itemsPromises);

                const itemsMap = {};
                itemsResponses.forEach((res, idx) => {
                    itemsMap[response.data[idx].orderID] = res.data;
                });

                setOrderItems(itemsMap);
            } catch (err) {
                console.error("Error fetching orders or items:", err);
                setError("Failed to load orders.");
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [currentGardener?.id]);

    if (loading) return <p>Loading orders...</p>;
    if (error) return <p>{error}</p>;
    if (orders.length === 0) return <p>No orders found.</p>;

    const selectedOrder = orders.find(o => o.orderID === selectedOrderID);

    return (
        <div className="orders-page">
            <h2>My Orders</h2>

            {/* MASTER TABLE */}
            <table className="orders-table">
                <thead>
                    <tr>
                        <th>Order #</th>
                        <th>Month</th>
                        <th>Method</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map(order => (
                        <tr
                            key={order.orderID}
                            onClick={() => setSelectedOrderID(order.orderID)}
                            style={{
                                cursor: "pointer",
                                background:
                                    selectedOrderID === order.orderID ? "#eef6ee" : "transparent"
                            }}
                        >
                            <td>{order.orderID}</td>
                            <td>{order.orderMonth}</td>
                            <td>{order.method}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* DETAIL PANEL */}
            {selectedOrder && (
                <div className="order-detail">
                    <h3>Order #{selectedOrder.orderID}</h3>

                    <WorkflowBubbles
                        orderID={selectedOrder.orderID}
                        method={selectedOrder.method}
                        isDemoMode={isDemoMode}
                    />

                    <div className="order-items">
                        <h4>Items Ordered</h4>

                        {orderItems[selectedOrder.orderID]?.length > 0 ? (
                            <ul>
                                {orderItems[selectedOrder.orderID].map(item => (
                                    <li key={item.id}>
                                        {item.supplierVariety || "Unknown Variety"} -{" "}
                                        {item.totalPackets} X {item.description}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No items found for this order.</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Orders;
